import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoadingWizardData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE,
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST,
    )]: () => true,
  },
  false,
);

export const wizardData = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE,
      actionTypes.RESET_ANNOUNCEMENT_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS,
    )]: (state, { payload }) => payload,
  },
  {},
);

export const isLoadingAnnouncements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENTS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_REQUEST,
    )]: () => true,
  },
  false,
);

export const announcements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS]: (state, { payload }) => payload.announcements,
    [actionTypes.DELETE_ANNOUNCEMENT_SUCCESS]: (state, { payload }) =>
      (state || [])?.filter(d => d.id !== payload.id),
    [actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS]: (state, { payload }) => state?.map((d) => {
      if (d.id === payload.id) {
        return payload;
      }
      return d;
    }),
    [actionTypes.ADD_ANNOUNCEMENT_SUCCESS]: (state, { payload }) => [
      ...state,
      payload,
    ],
  },
  [],
);

export const isUpdatingAnnouncement = handleActions(
  {
    [combineActions(
      actionTypes.ADD_ANNOUNCEMENT_SUCCESS,
      actionTypes.ADD_ANNOUNCEMENT_FAILURE,
      actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS,
      actionTypes.UPDATE_ANNOUNCEMENT_FAILURE,
      actionTypes.DELETE_ANNOUNCEMENT_SUCCESS,
      actionTypes.DELETE_ANNOUNCEMENT_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.ADD_ANNOUNCEMENT_REQUEST,
      actionTypes.UPDATE_ANNOUNCEMENT_REQUEST,
      actionTypes.DELETE_ANNOUNCEMENT_REQUEST,
    )]: () => true,
  },
  false,
);

export const updateAnnouncementSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_ANNOUNCEMENT_REQUEST,
      actionTypes.UPDATE_ANNOUNCEMENT_FAILURE,
      actionTypes.ADD_ANNOUNCEMENT_REQUEST,
      actionTypes.ADD_ANNOUNCEMENT_FAILURE,
      actionTypes.RESET_ANNOUNCEMENT_DATA,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS,
      actionTypes.ADD_ANNOUNCEMENT_SUCCESS,
    )]: () => true,
  },
  false,
);

export const isLoadingAnnouncement = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_FAILURE,
      actionTypes.FETCH_ANNOUNCEMENT_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_REQUEST,
    )]: () => true,
  },
  false,
);

export const announcement = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ANNOUNCEMENT_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENT_FAILURE,
      actionTypes.RESET_ANNOUNCEMENT_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENT_SUCCESS,
    )]: (state, { payload }) => payload || {},
  },
  {},
);

export const announcementsError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ANNOUNCEMENTS_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENTS_NEXT_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_NEXT_SUCCESS,
      actionTypes.UPDATE_ANNOUNCEMENT_REQUEST,
      actionTypes.UPDATE_ANNOUNCEMENT_SUCCESS,
      actionTypes.DELETE_ANNOUNCEMENT_REQUEST,
      actionTypes.DELETE_ANNOUNCEMENT_SUCCESS,
      actionTypes.ADD_ANNOUNCEMENT_REQUEST,
      actionTypes.ADD_ANNOUNCEMENT_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENT_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENT_SUCCESS,
      actionTypes.RESET_ANNOUNCEMENT_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FAILURE,
      actionTypes.FETCH_ANNOUNCEMENTS_NEXT_FAILURE,
      actionTypes.ADD_ANNOUNCEMENT_FAILURE,
      actionTypes.UPDATE_ANNOUNCEMENT_FAILURE,
      actionTypes.DELETE_ANNOUNCEMENT_FAILURE,
      actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

// Feed and sidepanel reducers

export const isLoadingSidepanelAnnouncements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => !payload.isHome ? false : state,
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
    )]: (state, { payload }) => !payload.isHome ? true : state,
  },
  false,
);

export const isSidepanelAnnouncementsLoaded = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS,
    )]: (state, { payload }) => !payload.isHome ? true : state,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
    )]: (state, { payload }) => !payload.isHome ? false : state,
  },
  false,
);

export const isLoadingHomeAnnouncements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.isHome ? false : state,
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
    )]: (state, { payload }) => payload.isHome ? true : state,
  },
  false,
);

export const sidepanelAnnouncements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.isHome ? state : [],
    [actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS]: (state, { payload }) => {
      if (!payload.isHome) {
        return payload.announcements.items;
      }
      return state;
    },
  },
  [],
);

export const homeAnnouncements = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.isHome ? [] : state,
    [actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS]: (state, { payload }) => {
      if (payload.isHome) {
        return payload.announcements.items;
      }
      return state;
    },
  },
  [],
);

export const announcementsSidepanelTotalCount = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.isHome ? state : 0,
    [actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS]: (state, { payload }) =>
      payload.isHome ? state : payload.announcements.totalCount,
  },
  0,
);

export const announcementsHomeTotalCount = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.isHome ? 0 : state,
    [actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS]: (state, { payload }) =>
      payload.isHome ? payload.announcements.totalCount : state,
  },
  0,
);

export const announcementsFeedError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST,
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_ANNOUNCEMENTS_FEED_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const announcementsSidepanelOpen = handleActions(
  {
    [actionTypes.OPEN_ANNOUNCEMENTS_SIDEPANEL]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CLOSE_ANNOUNCEMENTS_SIDEPANEL,
    )]: () => false,
  },
  false,
);

export const isSiepanelFeedback = handleActions(
  {
    [actionTypes.OPEN_ANNOUNCEMENTS_SIDEPANEL]: (state, { payload }) =>
      !!payload?.isFeedback,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CLOSE_ANNOUNCEMENTS_SIDEPANEL,
    )]: () => false,
  },
  false,
);

export const filterOnId = handleActions(
  {
    [actionTypes.OPEN_ANNOUNCEMENTS_SIDEPANEL]: (state, { payload }) =>
      payload?.filterOnId ? payload.filterOnId : null,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CLOSE_ANNOUNCEMENTS_SIDEPANEL,
    )]: () => null,
  },
  null,
);

export default combineReducers({
  isLoadingWizardData,
  wizardData,
  isLoadingAnnouncements,
  announcements,
  isLoadingAnnouncement,
  announcement,
  isUpdatingAnnouncement,
  updateAnnouncementSuccess,
  announcementsError,
  isLoadingSidepanelAnnouncements,
  isSidepanelAnnouncementsLoaded,
  sidepanelAnnouncements,
  isLoadingHomeAnnouncements,
  homeAnnouncements,
  announcementsSidepanelTotalCount,
  announcementsHomeTotalCount,
  announcementsFeedError,
  announcementsSidepanelOpen,
  isSiepanelFeedback,
  filterOnId,
});
